import _ from 'lodash';

import * as constants from './TrainingCamp.constants';
import * as services from './TrainingCamp.service';

const state = {
  courseTaskInfo: {},

  selectedBulletId: -1,

  selectedFileId: -1,

  res_checkAndAddCourseTask: {
    checkMessage: '',
    checkResult: 0,
  },
  isRequest: false,
};

const mutations = {
  [constants.GET_COURSE_TASK_INFO_SUCCESS](state, courseTaskInfo) {
    if (undefined !== courseTaskInfo && null !== courseTaskInfo) {
      state.courseTaskInfo = courseTaskInfo;
    }
  },

  [constants.CHECK_AND_ADD_COURSE_TASK_SUCCESS](state, payload) {
    if (undefined !== payload && null !== payload) {
      state.res_checkAndAddCourseTask = payload;
      if (1 === state.res_checkAndAddCourseTask.checkResult) {
        state.courseTaskInfo = {
          ...state.courseTaskInfo,
          alreadyInClass: true,
        };
      }
    }
  },

  [constants.SET_SELECTED_BULLET_ID](state, selectedBulletId) {
    if (undefined !== selectedBulletId && null !== selectedBulletId) {
      state.selectedBulletId = selectedBulletId;
    }
  },

  [constants.UPDATE_BULLET_SUBJECT](state, { video, subject, payload }) {
    const { taskId, bookId, readingId } = video ? video : subject;
    let bulletId, subjectId;
    if (video) {
      bulletId = video.bulletId;
    } else {
      subjectId = subject.subjectId;
    }
    const taskIdx = _.findIndex(state.courseTaskInfo.taskList, (task) => task.taskId === taskId);
    let task = state.courseTaskInfo.taskList[taskIdx];
    const bookIdx = _.findIndex(task.bookList, (book) => book.bookId === bookId);
    let book = task.bookList[bookIdx];
    const readingIdx = _.findIndex(book.readingList, (reading) => reading.readingId === readingId);
    let reading = book.readingList[readingIdx];
    if (video) {
      const bulletVideoIdx = _.findIndex(
        reading.bulletVideoList,
        (bulletVideo) => bulletVideo.bulletId === bulletId
      );
      let bulletVideo = reading.bulletVideoList[bulletVideoIdx];
      bulletVideo = {
        ...bulletVideo,
        ...payload,
      };
      reading.bulletVideoList.splice(bulletVideoIdx, 1, bulletVideo);
    } else {
      const subjectPointIdx = _.findIndex(
        reading.subjectPointList,
        (subjectPoint) => subjectPoint.subjectId === subjectId
      );
      let subjectPoint = reading.subjectPointList[subjectPointIdx];
      subjectPoint = {
        ...subjectPoint,
        ...payload,
      };
      reading.subjectPointList.splice(subjectPointIdx, 1, subjectPoint);
    }
    book.readingList.splice(readingIdx, 1, reading);
    task.bookList.splice(bookIdx, 1, book);
    state.courseTaskInfo.taskList.splice(taskIdx, 1, task);
  },

  [constants.SET_SELECTED_FILE_ID](state, selectedFileId) {
    state.selectedFileId = selectedFileId;
  },

  [constants.FILE_GENERATED_SUCCESS](state, { taskId, bookId, fileId, filePath }) {
    const taskIdx = _.findIndex(state.courseTaskInfo.taskList, (task) => task.taskId === taskId);
    let task = state.courseTaskInfo.taskList[taskIdx];
    const bookIdx = _.findIndex(task.bookList, (book) => book.bookId === bookId);
    let book = task.bookList[bookIdx];
    const fileIdx = _.findIndex(book.fileList, (file) => file.fileId === fileId);
    let file = book.fileList[fileIdx];
    file = {
      ...file,
      filePath,
    };
    book.fileList.splice(fileIdx, 1, file);
    task.bookList.splice(bookIdx, 1, book);
    state.courseTaskInfo.taskList.splice(taskIdx, 1, task);
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async _getCourseTaskInfo({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await payload.getCourseTaskInfo(payload.payload);
    commit(constants.GET_COURSE_TASK_INFO_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },

  getCourseTaskInfo({ dispatch }, payload) {
    return dispatch('_getCourseTaskInfo', {
      payload,
      getCourseTaskInfo: services.getCourseTaskInfo,
    });
  },

  getPersonalTaskInfo({ dispatch }, payload) {
    return dispatch('_getCourseTaskInfo', {
      payload,
      getCourseTaskInfo: services.getPersonalTaskInfo,
    });
  },

  async checkAndAddCourseTask({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.checkAndAddCourseTask(payload);
    commit(constants.CHECK_AND_ADD_COURSE_TASK_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },

  async addByClassidCourseTask({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.addByClassidCourseTask(payload);
    commit(constants.CHECK_AND_ADD_COURSE_TASK_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return res;
  },

  async generateFile({ commit }, payload) {
    const res = await services.generateFile(payload);
    commit(constants.FILE_GENERATED_SUCCESS, { ...payload, filePath: res.data.data });
  },
};

const getters = {
  courseTaskInfo: (state) => {
    const courseTaskInfo = {
      ...state.courseTaskInfo,
      taskList: _.map(state.courseTaskInfo.taskList, (task) => ({
        ...task,
        bookList: _.map(task.bookList, (book) => ({
          ...book,
          readingList: _.map(book.readingList, (reading) => ({
            ...reading,
            bulletVideoList: _.map(reading.bulletVideoList, (bulletVideo) => ({
              ...bulletVideo,
              taskId: task.taskId,
              bookId: book.bookId,
              readingId: reading.readingId,
            })),
            subjectPointList: _.map(reading.subjectPointList, (subjectPoint) => ({
              ...subjectPoint,
              taskId: task.taskId,
              bookId: book.bookId,
              readingId: reading.readingId,
            })),
          })),
        })),
      })),
    };
    return courseTaskInfo;
  },

  readingList: (state, getters) => {
    const taskList = getters.courseTaskInfo.taskList;
    const bookLists = _.map(taskList, (task) => task.bookList);
    const bookList = _.flatten(bookLists);
    const readingLists = _.map(bookList, (book) => book.readingList);
    const readingList = _.flatten(readingLists);
    return readingList;
  },

  ReadyToPlayVideos: (state, getters) => {
    const bulletVideoLists = _.map(getters.readingList, (reading) => reading.bulletVideoList);
    let bulletVideoList = _.flatten(bulletVideoLists);
    bulletVideoList = _.map(bulletVideoList, (bulletVideo) => ({
      ...bulletVideo,
      speed1: bulletVideo.vpath,
      speed1Dot3: bulletVideo.vpath_1_3,
      speed1Dot5: bulletVideo.vpath_1_5,
      speed2: bulletVideo.vpath_2,
      isLatest: false,
    }));
    if (bulletVideoList.length > 0) {
      bulletVideoList[bulletVideoList.length - 1].isLatest = true;
    }
    return bulletVideoList;
  },

  subjectPoints: (state, getters) => {
    const subjectPointLists = _.map(getters.readingList, (reading) => reading.subjectPointList);
    let subjectPointList = _.flatten(subjectPointLists);
    return subjectPointList;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
